import React from "react";
import { AlertCircle } from "lucide-react";
import { STATUS_DONE } from "utils/constants/others";
import { ASNModalTitle } from "./styles.advanceShippingNoteDetails";
import {
  LocationHintCard,
  LocationHintRow,
  OutcomeIconCircle,
  OutcomeRetryButton,
  OutOfRangeSubtitle,
  SuccessIcon,
  SuccessState,
  SuccessSubtitle,
} from "./styles.publicMarkEntry";
import { STATUS_LOCATION_ERROR, STATUS_OUT_OF_RANGE } from "./useMarkArrived";

const MarkArrivedOutcome = ({ status, onRetry, radiusInMeters }) => {
  if (status === STATUS_DONE) {
    return (
      <SuccessState>
        <SuccessIcon src="/logos/tick_logo.svg" alt="" />
        <ASNModalTitle>Entry marked successfully</ASNModalTitle>
        <SuccessSubtitle>Report to the security staff at entry gate</SuccessSubtitle>
      </SuccessState>
    );
  }

  if (status === STATUS_OUT_OF_RANGE) {
    const radiusText =
      radiusInMeters !== null && radiusInMeters !== undefined ? `${radiusInMeters}m` : "200m";
    return (
      <SuccessState>
        <OutcomeIconCircle>
          <img src="/logos/within_location.svg" alt="" />
        </OutcomeIconCircle>
        <ASNModalTitle>Entry not marked</ASNModalTitle>
        <OutOfRangeSubtitle>Ensure you're within {radiusText} of warehouse</OutOfRangeSubtitle>
        <OutcomeRetryButton type="button" onClick={onRetry}>
          Retry
        </OutcomeRetryButton>
      </SuccessState>
    );
  }

  if (status === STATUS_LOCATION_ERROR) {
    return (
      <SuccessState>
        <OutcomeIconCircle>
          <img src="/logos/cross-circle-fill-2.svg" alt="" />
        </OutcomeIconCircle>
        <ASNModalTitle>Entry not marked</ASNModalTitle>
        <LocationHintCard>
          <LocationHintRow>
            <AlertCircle aria-hidden="true" />
            <span>Enable location in device settings</span>
          </LocationHintRow>
          <LocationHintRow>
            <AlertCircle aria-hidden="true" />
            <span>Press &lsquo;Allow&rsquo; when asked in next step</span>
          </LocationHintRow>
        </LocationHintCard>
        <OutcomeRetryButton type="button" onClick={onRetry}>
          Retry
        </OutcomeRetryButton>
      </SuccessState>
    );
  }

  return null;
};

export default MarkArrivedOutcome;
